const SECURE = 's';

export default {
  API_URL: 'apibeta.who-is.app',
  SECURITY: SECURE,
  URL: 'beta.who-is.app',
};
